// @flow

import { DRIFT_EVENTS } from './events'

type GAAttachArgs = {
  trackingName?: any,
  enabledEventMappings?: Object,
  individualEventsEnabled?: boolean
}

const resolveEventLabel = (event: string, payload: Object) => {
  return DRIFT_EVENTS[event].label
    ? DRIFT_EVENTS[event].label(payload)
    : ''
}

const getGA = () => {
  return window.GoogleAnalyticsObject
    ? window[window.GoogleAnalyticsObject]
    : (
      window.ga
        ? window.ga
        : window._gaq
    )
}

const isLegacyGa = () => !!window._gaq

const resolveUAInstanceMethod = (gaId: any) => {
  const UAInstance = getGA().getAll
  ? getGA().getAll()[0].get('name')
  : null

  return (gaId || UAInstance)
    ? `${gaId || UAInstance}.send`
    : 'send'
}

const GAPassThrough = (event: string, payload: Object, gaId: any) => {
  const GA = getGA()
  if(!GA) {return}
  if(isLegacyGa()) {
    window._gaq.push([
      '_trackEvent', //method
      'Drift Widget', //category
      DRIFT_EVENTS[event].action, //action
      resolveEventLabel(event, payload), //label
      undefined, //value
      DRIFT_EVENTS[event].nonInteraction //non interaction
    ])
  } else {
    GA(resolveUAInstanceMethod(gaId), 'event', {
      eventCategory: 'Drift Widget',
      eventAction: DRIFT_EVENTS[event].action,
      eventLabel: resolveEventLabel(event, payload),
      nonInteraction: DRIFT_EVENTS[event].nonInteraction
    })
  }
}

const attachListeners = ({
  trackingName: gaId = null,
  enabledEventMappings = {},
  individualEventsEnabled = false
}: GAAttachArgs) => {

  const attachListener = event => {
    if(!individualEventsEnabled || enabledEventMappings[event]) {
      window.drift('on', event, (payload) => GAPassThrough(event, payload, gaId))
    }
  }

  Object.keys(DRIFT_EVENTS)
    .forEach(attachListener)
}

export default (config: GAAttachArgs = {}) => {
  attachListeners(config)
}
